import { LimitSection } from 'components/secondaryMarket/limitOrder/sections/LimitSection';
import { connectLimitSection } from 'components/secondaryMarket/limitOrder/sections/LimitSection.connect';
import { SecondaryBookingInformation } from 'components/secondaryMarket/shared/sections/SecondaryBookingInformation';
import { secondaryMarketBookingInformationConnectFactory } from 'components/secondaryMarket/shared/sections/SecondaryBookingInformation.connect';
import { SecondaryProductSummary } from 'components/secondaryMarket/shared/sections/SecondaryProductSummary';
import { secondaryMarketProductSummaryConnectFactory } from 'components/secondaryMarket/shared/sections/SecondaryProductSummary.connect';
import { SecondaryTradeInformation } from 'components/secondaryMarket/shared/sections/SecondaryTradeInformation';
import { secondaryMarketTradeInformationConnectFactory } from 'components/secondaryMarket/shared/sections/SecondaryTradeInformation.connect';
import { connect } from 'react-redux';
import { limitOrderInputFormActions } from 'state/secondaryMarket/limit-order/form/input/inputForm.actions';
import { limitOrderInputFormSelectors } from 'state/secondaryMarket/limit-order/form/input/inputForm.selectors';
import { limitOrderSelectors } from 'state/secondaryMarket/limit-order/limitOrder.selector';
import { limitOrderThunks } from 'state/secondaryMarket/limit-order/limitOrder.thunk';
import { limitOrderReferentialSelectors } from 'state/secondaryMarket/limit-order/referential/referential.selector';
import type { SecondaryWorkspaceType } from 'state/workspaces/model';

export const connectedLimitOrderSections = (workspaceType: SecondaryWorkspaceType) => {
  const productSummaryConnectParams = secondaryMarketProductSummaryConnectFactory(
    limitOrderReferentialSelectors,
    limitOrderSelectors,
    limitOrderThunks,
    workspaceType,
  );
  const tradeInformationConnectParams = secondaryMarketTradeInformationConnectFactory(
    limitOrderReferentialSelectors,
    limitOrderInputFormSelectors,
    limitOrderSelectors,
    limitOrderThunks,
    workspaceType,
  );

  const bookingInformationConnectParams = secondaryMarketBookingInformationConnectFactory(
    limitOrderReferentialSelectors,
    limitOrderSelectors,
    limitOrderInputFormActions,
  );
  return {
    ConnectedProductSummary: connect(
      productSummaryConnectParams.mapStateToProps,
      productSummaryConnectParams.mapDispatchToProps,
    )(SecondaryProductSummary),
    ConnectedTradeInformation: connect(
      tradeInformationConnectParams.mapStateToProps,
      tradeInformationConnectParams.mapDispatchToProps,
    )(SecondaryTradeInformation),
    ConnectedBookingInformation: connect(
      bookingInformationConnectParams.mapStateToProps,
      bookingInformationConnectParams.mapDispatchToProps,
    )(SecondaryBookingInformation),
    ConnectedLimit: connectLimitSection(LimitSection),
  };
};
